var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { Form } from '../../../components';
import { FieldType } from '../../../elements';
import { rules } from '../../../helpers/Validation';
var OtasForm = /** @class */ (function (_super) {
    __extends(OtasForm, _super);
    function OtasForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fields = [
            {
                name: 'name',
                column: 'nameOta',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required()
                    .alphaDashSpace(),
                size: 4
            },
            {
                name: 'description',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 4
            },
            {
                name: 'publicApiToken',
                type: FieldType.Text,
                rules: rules()
                    .string(),
                size: 4
            },
            {
                name: 'privateApiToken',
                type: FieldType.Text,
                rules: rules()
                    .string(),
                size: 4
            }
        ];
        return _this;
    }
    OtasForm.prototype.render = function () {
        var ota = this.props.ota;
        var otaStore = this.props.store.otaStore;
        return (React.createElement(Form, { calculator: true, loading: ['post@otas', 'put@otas', 'patch@otas'], fields: this.fields, values: ota, store: otaStore, stores: this.props.store }));
    };
    OtasForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id ?
                props.store.otaStore.read(props.match.params.id)
                    .then(function (ota) { return ({ ota: ota }); })
                :
                    undefined,
        ]; }),
        observer
    ], OtasForm);
    return OtasForm;
}(Component));
export default OtasForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Otas/containers/OtasForm.tsx
// module id = 1593
// module chunks = 0